import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { ListItem } from "@website/ui/list-item";
import { Popover } from "@website/ui/popover";
import { numberConvert } from "@website/utils/number-convert";
import { useToggle } from "@website/utils/use-toggle/useToggle";
export function SupportAgent() {
  const $ = _c(15);
  const [supportMenuIsOpen, toggleSupportMenu] = useToggle(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <MaterialIcon name="support_agent" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== toggleSupportMenu) {
    t1 = <Button StartIcon={t0} aria-label={"\u0646\u0645\u0627\u06CC\u0634 \u0644\u06CC\u0646\u06A9 \u0647\u0627\u06CC \u067E\u0634\u062A\u06CC\u0628\u0627\u0646\u06CC"} color="neutral" onClick={toggleSupportMenu} role="button" variant="text" className="!mx-0 max-xl:!hidden">پشتیبانی</Button>;
    $[1] = toggleSupportMenu;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <MaterialIcon name="support_agent" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== toggleSupportMenu) {
    t3 = <Button EndIcon={t2} className="!mx-0 xl:!hidden" color="neutral" equalDimension={true} onClick={toggleSupportMenu} variant="text" />;
    $[4] = toggleSupportMenu;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <MaterialIcon name="support_agent" />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="w-[312px] rounded-lg py-2"><ListItem StartIcon={t4} aria-label={"\u062A\u0645\u0627\u0633 \u0628\u0627 \u067E\u0634\u062A\u06CC\u0628\u0627\u0646\u06CC"} href="tel:+982192000123" role="link" subtitle={<div className="text-end" style={{
        direction: "ltr"
      }}>{numberConvert("+98 21 92000123", {
          locale: "fa"
        })}</div>} title={"\u062A\u0645\u0627\u0633 \u0628\u0627 \u067E\u0634\u062A\u06CC\u0628\u0627\u0646\u06CC"} /></div>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== supportMenuIsOpen || $[9] !== toggleSupportMenu) {
    t6 = <Popover gap="16px" horizontalPosition="end" onClose={toggleSupportMenu} open={supportMenuIsOpen}>{t5}</Popover>;
    $[8] = supportMenuIsOpen;
    $[9] = toggleSupportMenu;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t1 || $[12] !== t3 || $[13] !== t6) {
    t7 = <div className="relative">{t1}{t3}{t6}</div>;
    $[11] = t1;
    $[12] = t3;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}